<template>
    <tq-image :pb_src_r="ass_img_copy2_b" @click.native="m_copyText_f" class="TQ_clickable TQ_verticalAlignMiddle"> </tq-image>

</template>

<script>
    import {ass_img_copy2_b} from "../../assets/scripts/Ass_Files";
    import TqImage from "../basic/TqImage";
    import {helper_copyStringToClipboard} from "../../scripts/S_Helper";
    import {notification_notify2} from "../../scripts/S_Notification";

    export default {
        name: "TqCopy",
        components: {TqImage},
        props:{
            p_copyStr_s:{
                type: String,
                require:true
            },
            p_notificationText_s:{
                type: String,
                require:true
            },
        },
        data(){
            return {
                ass_img_copy2_b : ass_img_copy2_b,
            }
        },
        methods:{
            m_copyText_f(){
                helper_copyStringToClipboard(this.p_copyStr_s)
                notification_notify2({title_s: this.p_notificationText_s})
            }
        }
    }
</script>

<style scoped>

</style>